<gast-onset-cloze-test style="height: 100%;"
  [mobileMode]="isMobile"
  [clozeTestModel]="clozeTestModel"
  [clozeTestStyleModel]="clozeTestStyleModel"
  [showResult]="true"
  [showEndTestButton]="false"
  [lang]="lang"
  (startTest)=onStartTest($event)
  (bookingInitialized)=onBookingInit($event)
  (testSaved)=onTestHasBeenSaved($event)
  (clozeTest)=onClozeTestCompleted()
  (testResult)=onTestResult($event)
></gast-onset-cloze-test>